class VisibilityTracker {
  #isElementVisible = false;
  #observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  constructor(targetElement, customObserverOptions = {}) {
    this.targetElement = targetElement;
    this.#observerOptions = Object.assign(
      this.#observerOptions,
      customObserverOptions
    );
  }

  track(callableWhenVisible) {
    let observerCallbackWhenVisible = this._observerCallback(
      callableWhenVisible
    );
    this.observer = new IntersectionObserver(
      observerCallbackWhenVisible.bind(this),
      this.#observerOptions
    );
    this.observer.observe(this.targetElement);
  }

  untrack() {
    this.observer.unobserve(this.targetElement);
  }

  isElementSeen() {
    return this.#isElementVisible;
  }

  _observerCallback(callable) {
    // eslint-disable-next-line no-unused-vars
    return function(entries, _observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.#isElementVisible = true;
          callable();
        }
      });
    };
  }
}

export default VisibilityTracker;
